/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleRentalHistoryItem
 */
export interface VehicleRentalHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    vendorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    vehicleClass?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    vehicleCategory?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalHistoryItem
     */
    dailyRate?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    billingCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    pickupLocationCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRentalHistoryItem
     */
    pickupDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalHistoryItem
     */
    bookingAgent?: string;
}

/**
 * Check if a given object implements the VehicleRentalHistoryItem interface.
 */
export function instanceOfVehicleRentalHistoryItem(value: object): value is VehicleRentalHistoryItem {
    return true;
}

export function VehicleRentalHistoryItemFromJSON(json: any): VehicleRentalHistoryItem {
    return VehicleRentalHistoryItemFromJSONTyped(json, false);
}

export function VehicleRentalHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'vendorCode': json['vendor_code'] == null ? undefined : json['vendor_code'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
        'vehicleCategory': json['vehicle_category'] == null ? undefined : json['vehicle_category'],
        'dailyRate': json['daily_rate'] == null ? undefined : json['daily_rate'],
        'billingCurrency': json['billing_currency'] == null ? undefined : json['billing_currency'],
        'pickupLocationCode': json['pickup_location_code'] == null ? undefined : json['pickup_location_code'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : (new Date(json['pickup_datetime'])),
        'bookingAgent': json['booking_agent'] == null ? undefined : json['booking_agent'],
    };
}

export function VehicleRentalHistoryItemToJSON(json: any): VehicleRentalHistoryItem {
    return VehicleRentalHistoryItemToJSONTyped(json, false);
}

export function VehicleRentalHistoryItemToJSONTyped(value?: VehicleRentalHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_name': value['vendorName'],
        'vendor_code': value['vendorCode'],
        'vehicle_class': value['vehicleClass'],
        'vehicle_category': value['vehicleCategory'],
        'daily_rate': value['dailyRate'],
        'billing_currency': value['billingCurrency'],
        'pickup_location_code': value['pickupLocationCode'],
        'pickup_datetime': value['pickupDatetime'] == null ? value['pickupDatetime'] : value['pickupDatetime'].toISOString(),
        'booking_agent': value['bookingAgent'],
    };
}

